<template>
  <div>
    <SearchBox02></SearchBox02>
    <Content01></Content01>
  </div>

</template>

<script>
import SearchBox02 from "@/views/components/components2/SearchBox02.vue";
import Content01 from "@/views/components/components2/Content01.vue";

export default {
  name: "Baidu02",
  components: {Content01, SearchBox02}
}
</script>

<style scoped>

</style>